/**
 * Who may take back a document rejection, accepting the document as it was
 * uploaded (say, a CR12 accepted as an exception). Mirrors the server's
 * POST /api/documents/:id/recall-rejection, which refuses once the supplier
 * has uploaded a replacement: that replacement is what to review instead.
 */
const RECALL_ROLES = ['procurement', 'legal', 'super_admin'];

const timeOf = (d) => new Date(d || 0).getTime();

export const hasReplacement = (doc, documents = []) => documents.some((other) => other._id !== doc._id
  && other.documentType === doc.documentType
  && timeOf(other.createdAt || other.uploadedAt) > timeOf(doc.reviewedAt || doc.createdAt));

export const canRecallRejection = (user, doc, documents = []) => RECALL_ROLES.includes(user?.role)
  && doc?.status === 'rejected'
  && !hasReplacement(doc, documents);
